import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import Homepage from "./components/homepage";
import Loading from "./components/loading";

// Route-level code splitting: the homepage stays in the main chunk, everything
// else loads on demand so login → /accounts doesn't pay for admin/blog/shop.
const Shop = lazy(() => import("./components/shop"));
const Auth = lazy(() => import("./components/auth"));
const Builder = lazy(() => import("./components/builder"));
const Admin = lazy(() => import("./components/admin"));
const Blog = lazy(() => import("./components/blog"));
const BlogEntry = lazy(() => import("./components/blog/entry"));
const AvifDemo = lazy(() => import("./components/avif"));
const Settings = lazy(() => import("./components/settings"));
const SharedProfile = lazy(() => import("./components/accounts/profile"));
const PlansPage = lazy(() => import("./components/pages").then((m) => ({ default: m.PlansPage })));
const PartnersPage = lazy(() => import("./components/pages").then((m) => ({ default: m.PartnersPage })));
const ContactPage = lazy(() => import("./components/pages").then((m) => ({ default: m.ContactPage })));
const PrivacyPage = lazy(() => import("./components/pages").then((m) => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import("./components/pages").then((m) => ({ default: m.TermsPage })));

const AppRouter = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="shop" element={<Shop />} />
        <Route path="accounts" element={<Builder />} />
        <Route path="admin" element={<Admin />} />
        <Route path="blog" element={<Blog />} />
        {/* Category listing (/blog/nfc-technology) or post (/blog/my-slug). */}
        <Route path="blog/:slugId" element={<BlogEntry />} />
        <Route path="plans" element={<PlansPage />} />
        <Route path="partners" element={<PartnersPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        {/* Static segments outrank ":slug" in v6 ranking, so this wins over the
            public card page rather than being swallowed by it. */}
        <Route path="avif" element={<AvifDemo />} />
        <Route path=":slug" element={<SharedProfile />} />
        <Route path="settings" element={<Settings />} />
        <Route path="auth/password/reset/:slug" element={<Auth type="reset" />} />
        <Route path="auth/password/create/:slug" element={<Auth type="create" />} />
        <Route path="login" element={<Auth type="login" />} />
        <Route path="verification" element={<Auth type="verification" />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
